import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../axiosInstance";
import AdLayout from "../components/AdLayout";
import { fetchPriceLevelPermissions } from "../libs/customerCreatePermission";
import Levels from "./Levels";
import UserManagement from "./UserManagement";
import "./customerManagement.css";

export const CUSTOMER_TAB_LIST = "khach-hang";
export const CUSTOMER_TAB_PRICE_LEVEL = "bang-gia";

/**
 * Trang Quản lý khách hàng: tab Danh sách khách hàng + tab Bảng giá.
 * Tab lưu trên URL (?tab=bang-gia). Chỉ mount tab đang mở — hai màn dùng chung .form_filter / window.calling.
 */
const CustomerManagementPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [canViewPriceLevel, setCanViewPriceLevel] = useState(false);
  const [permLoaded, setPermLoaded] = useState(false);
  const requestedTab = searchParams.get("tab");
  const tab = requestedTab === CUSTOMER_TAB_PRICE_LEVEL && canViewPriceLevel ? CUSTOMER_TAB_PRICE_LEVEL : CUSTOMER_TAB_LIST;

  useEffect(() => {
    let cancelled = false;
    fetchPriceLevelPermissions(axiosInstance).then((perm) => {
      if (cancelled) return;
      setCanViewPriceLevel(Boolean(perm?.canView));
      setPermLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const openTab = (next) => {
    if (next === tab) return;
    // Lượt tìm của tab cũ có thể còn chạy: bỏ cờ chống gọi trùng để tab mới tải được dữ liệu.
    window.calling = false;
    const params = new URLSearchParams(searchParams);
    if (next === CUSTOMER_TAB_LIST) params.delete("tab");
    else params.set("tab", next);
    setSearchParams(params, { replace: true });
  };

  return (
    <div>
      <AdLayout>
        {canViewPriceLevel && (
          <ul className="nav nav-tabs mt-2 customer-management-tabs">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${tab === CUSTOMER_TAB_LIST ? "active" : ""}`}
                onClick={() => openTab(CUSTOMER_TAB_LIST)}
              >
                Danh sách khách hàng
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${tab === CUSTOMER_TAB_PRICE_LEVEL ? "active" : ""}`}
                onClick={() => openTab(CUSTOMER_TAB_PRICE_LEVEL)}
              >
                Bảng giá
              </button>
            </li>
          </ul>
        )}
        {/* Chờ biết quyền Bảng giá rồi mới mount, tránh mount nhầm tab khi mở thẳng ?tab=bang-gia. */}
        {permLoaded && (tab === CUSTOMER_TAB_PRICE_LEVEL ? <Levels embedded /> : <UserManagement embedded />)}
      </AdLayout>
    </div>
  );
};

export default CustomerManagementPage;
